import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getHomepagePageData } from './api';
import type { HomepagePageDataLoadError } from './types';

export const {
	Context: HomepagePageDataContext,
	Provider: HomepagePageDataContextProvider,
	useContext: useHomepagePageData,
	useAsyncData: useHomepagePageDataFromApi,
	prefetchAsyncData: prefetchHomepagePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'HomepagePageDataContext',
	dataProperty: 'pageData',
	getData: getHomepagePageData,
	errorHandler: pageDataErrorHandler<HomepagePageDataLoadError>(),
});
